export default __webpack_public_path__ + "static/media/downloadfile.3c59a7a5.svg";